/// <amd-module name="Repos/Views/Settings/Repositories/Components/DeleteDialog" />
import React = require("react");
import { DialogType, IRepository } from "Repos/Views/Settings/Repositories/Contracts/Contracts";
import * as Resources from "Repos/Views/Settings/Repositories/Resources";
import { IRepositoriesViewService } from "Repos/Views/Settings/Repositories/Services/RepositoriesViewService";
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import * as Utils from "VSS/Core/Util/String";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Observer } from "VSSUI/Observer";
import { RepositoryDialog } from "./RepositoryDialog";

export class DeleteDialog extends VssComponent {
    private repository: IReadonlyObservableValue<IRepository | undefined>;
    private svc: IRepositoriesViewService;

    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);
        this.svc = context.pageContext.getService<IRepositoriesViewService>("RepositoriesViewService");
        this.repository = this.svc.getDialogRepository();
    }

    public render = (): JSX.Element => {
        return (
            <Observer repo={this.repository}>
                {(props: { repo: IRepository | undefined }) => {
                    return props.repo ? (
                        <RepositoryDialog
                            dialogType={DialogType.Delete}
                            message={Utils.format(Resources.DeleteMessage, props.repo.name)}
                            primaryButtonText={Resources.Delete}
                            textboxPlaceholder={Resources.DeletePlaceholder}
                            textBoxInitialValue={""}
                            title={Utils.format(Resources.DeleteTitle, props.repo.name)}
                            getActionPromise={this.getActionPromise}
                            primaryButtonDanger={true}
                            primaryButtonDisabled={this.primaryButtonDisabled}
                        />
                    ) : null;
                }}
            </Observer>
        );
    };

    private getActionPromise = (textboxValue: string) => {
        return this.svc.deleteRepository(this.repository.value as IRepository);
    };

    private primaryButtonDisabled = (text: string) => {
        return !!this.repository.value && this.repository.value.name.toLocaleLowerCase() !== text.toLocaleLowerCase();
    };
}
